import { AlertOctagon, RefreshCw, Home } from 'lucide-react';


const SomeThingWentWrong = () => {
  return (
    <div className="min-vh-100 bg-light d-flex align-items-center justify-content-center py-4">
    <div className="card shadow-lg text-center" style={{ maxWidth: '500px', width: '100%' }}>
      <div className="card-body p-4">
        <div className="d-flex justify-content-center mb-4">
          <AlertOctagon size={64} className="text-danger" strokeWidth={1.5} />
        </div>

        <h1 className="h3 fw-bold text-dark mb-3">
          Oops! Something went wrong
        </h1>

        <p className="text-secondary mb-4">
          We're sorry, but it seems like we've encountered an unexpected error. 
          Our team has been notified and is working to fix the issue.
        </p>

        <div className="d-grid gap-2 d-sm-flex justify-content-sm-center mb-4">
          <button 
            className="btn btn-danger d-flex align-items-center justify-content-center"
            onClick={() => window.location.reload()}
          >
            <RefreshCw size={18} className="me-2" />
            Try Again
          </button>

          <button 
            className="btn btn-outline-secondary d-flex align-items-center justify-content-center"
            onClick={() => window.location.href = '/'}
          >
            <Home size={18} className="me-2" />
            Go Home
          </button>
        </div>

        <div className="border-top pt-3">
          <p className="small text-muted">
            If the problem persists, please contact our support team at{' '}
            <a href="mailto:support@goodhand.ae" className="text-danger fw-medium">
            support@goodhand.ae
            </a>
          </p>
        </div>
      </div>
    </div>
  </div>
  )
}

export default SomeThingWentWrong
